@if (event.scoreboard.started) {
    @if (penaltyShootout) {
        <ms-penalty-shootout [scoreboard]="event.scoreboard" />
    } @else {
        @switch (event.scoreboard.type) {
            @case (scoreboardType.BaseballGame) {
                <ms-baseball-scoreboard [scoreboard]="event.scoreboard" [sportId]="event.sport.id" />
            }
            @case (scoreboardType.Cricket) {
                <ms-cricket-scoreboard [scoreboard]="event.scoreboard" />
            }
            @case (scoreboardType.SetGame) {
                <ms-set-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [hideScoreBoardColumnFooter]="hideScoreBoardColumnFooter" />
            }
            @case (scoreboardType.Darts) {
                <ms-darts-scoreboard [scoreboard]="event.scoreboard" [hideScoreBoardColumnFooter]="hideScoreBoardColumnFooter" />
            }
            @case (scoreboardType.PairGame) {
                <ms-pair-game-scoreboard [showRedcards]="showRedcards" [event]="event" [tracking]="tracking" />
            }
            @case (scoreboardType.PeriodGame) {
                <ms-period-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" />
            }
            @case (scoreboardType.Snooker) {
                <ms-snooker-scoreboard [scoreboard]="event.scoreboard" [hideScoreBoardColumnFooter]="hideScoreBoardColumnFooter" />
            }
            @case (scoreboardType.LeaderboardGame) {
                <ms-leaderboard-game-scoreboard [scoreboard]="event.scoreboard" />
            }
        }
    }
}
